import { ArrowBack } from "@mui/icons-material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TabPanel from "../../components/TabPanel";
import {
  listDetailsCampaign,
  listDetailsCampaignClickRate,
} from "../../services/campaigns";
import {
  listDetailsResultCampaign,
  listRescueCampaign,
} from "../../services/results";
import { SendGroup } from "./SendGroup";
import { useStyles } from "./styles";

export function DetailsResults() {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [activeView, setActiveView] = useState<number>(0);

  const handleChangeView = useCallback((view: number) => {
    setActiveView(view);
  }, []);

  const handleNavigateGoToBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const campaignDetails = useQuery(["campaignDetails", params?.id], () =>
    listDetailsResultCampaign(
      location.state["startDate"],
      location.state["endDate"],
      Number(params?.id)
    )
  );

  const clickRate = useQuery(
    ["clickRate", params?.id],
    () => listDetailsCampaignClickRate(Number(params?.id)),
    { enabled: Boolean(params?.id) }
  );

  const campaignPerformance = useQuery(
    ["campaignPerformance", params?.id],
    () => listDetailsCampaign(Number(params?.id)),
    { enabled: Boolean(params?.id) }
  );

  const rescue = useQuery(
    ["rescue", params?.id],
    () =>
      listRescueCampaign(
        location.state["startDate"],
        location.state["endDate"],
        Number(params?.id)
      ),
    {
      enabled: Boolean(params?.id),
    }
  );

  const detailCampaign = useMemo(() => {
    return campaignDetails.data?.detalhesCampanha[0];
  }, [campaignDetails.data]);

  const controlGroup = useMemo(() => {
    return campaignDetails.data?.detalhesCampanha[0]?.pareto?.split("/");
  }, [campaignDetails.data]);

  return (
    <>
      <Stack spacing={4} className={styles.root}>
        <Stack direction="row" spacing={1}>
          <Tooltip placement="top" title="Voltar">
            <IconButton onClick={handleNavigateGoToBack}>
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Typography variant="h4">{location?.state["name"]}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1}>
            {controlGroup && (
              <>
                <Button
                  onClick={() => handleChangeView(0)}
                  variant={activeView === 0 ? "contained" : "outlined"}
                >
                  {`Grupo de disparo - ${controlGroup[0]}%`}
                </Button>
                {Number(controlGroup[0]) !== 100 && (
                  <Button
                    onClick={() => handleChangeView(1)}
                    variant={activeView === 1 ? "contained" : "outlined"}
                  >
                    {`Grupo de controle - ${controlGroup[1]}%`}
                  </Button>
                )}
              </>
            )}
          </Stack>
        </Stack>
        <TabPanel index={0} value={activeView}>
          <SendGroup
            loading={
              campaignDetails.isLoading ||
              rescue.isLoading ||
              campaignPerformance.isLoading
            }
            campaign={detailCampaign}
            rescue={rescue.data?.detalhe}
            rescueDetail={rescue.data?.lista}
            clickRate={clickRate.data}
            store={campaignDetails.data?.vendasLoja}
            hours={campaignDetails.data?.vendasHora}
            day={campaignDetails.data?.vendasDia}
            genre={campaignDetails.data?.genero}
            ageGroup={campaignDetails.data?.faixaEtaria}
            status={campaignPerformance.data?.status}
          />
        </TabPanel>
      </Stack>
    </>
  );
}
